import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['copyText']
  static values = {
    code: String,
    clickToCopy: String,
    copiedCode: String,
    copyFailed: String
  }

  connect() {
    if (this.hasCopyTextTarget) {
      this.copyTextTarget.textContent = this.clickToCopyValue
    }
  }

  async copy() {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(this.codeValue)
        this.setSuccessMessage()
      } else {
        this.copyWithFallback()
      }
      this.resetTextAfterDelay()
    } catch (error) {
      console.error('Clipboard copy failed:', error)
      this.copyTextTarget.textContent = this.copyFailedValue
      this.resetTextAfterDelay()
    }
  }

  copyWithFallback() {
    const textArea = document.createElement('textarea')
    textArea.value = this.codeValue
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    
    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.setSuccessMessage()
      } else {
        this.copyTextTarget.textContent = this.copyFailedValue
      }
    } finally {
      document.body.removeChild(textArea)
    }
  }

  setSuccessMessage() {
    if (this.copiedCodeValue.includes('%{code}')) {
      this.copyTextTarget.textContent = this.copiedCodeValue.replace('%{code}', this.codeValue)
    } else {
      this.copyTextTarget.textContent = this.copiedCodeValue
    }
  }

  resetTextAfterDelay() {
    setTimeout(() => {
      if (this.hasCopyTextTarget) {
        this.copyTextTarget.textContent = this.clickToCopyValue
      }
    }, 1000)
  }
}
